import TeamUpCalendar from "@/components/TeamUpCalendar";
import Seo from "@/components/Seo";

export default function Book() {
  return (
    <div>
      <Seo
        title="Book a class or consultation — Kore Wellbeing"
        description="Book any Kore Wellbeing class, free trial or coached session using the live GoTeamUp calendar. Instant booking for members and first-time visitors alike."
        path="/book"
      />
      <section className="container-kore pt-16 pb-8">
        <span className="eyebrow">Book</span>
        <h1 className="display-1 mt-4 text-kore-forest max-w-3xl">
          Book a class. <em className="italic text-kore-gold not-italic">Start today.</em>
        </h1>
        <p className="mt-6 text-kore-ink/70 max-w-xl font-light">
          Browse the timetable, create your account and book straight into a session. New members can start a free trial from the calendar below.
        </p>
      </section>

      <section data-testid="book-calendar-section" className="container-kore pb-24">
        <TeamUpCalendar />
        <p className="mt-6 text-xs text-kore-ink/50 max-w-2xl">
          Bookings, memberships and free trials are handled securely by TeamUp. You'll create an account the first time you book — after that, everything sits in one place.
        </p>
      </section>
    </div>
  );
}
